(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-dijon-red-launch"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const video = root.querySelector('video');
    const mobile = matchMedia('(max-width:749px)');
    let loaded = false, visible = true;
    video.muted = true;
    video.loop = true;
    video.controls = false;
    function sync() {
      if (mobile.matches && !video.poster) video.poster = video.dataset.poster;
      if (mobile.matches && visible && !document.hidden) {
        if (!loaded && video.dataset.src) {
          video.src = video.dataset.src;
          video.load();
          loaded = true;
        }
        if (loaded) video.play().catch(() => {});
      } else video.pause();
    }
    mobile.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold:.1}).observe(root);
    sync();
  }
  document.querySelectorAll('[data-red-mobile]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-red-mobile]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-launch-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{
function mount(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const video=root.querySelector('video'),mobile=matchMedia('(max-width:749px)'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
let visible=true,current='';
function select(){const mode=mobile.matches?'mobile':'desktop',src=root.dataset[mode]||root.dataset.desktop;if(src!==current){current=src;video.pause();video.poster=root.dataset[mobile.matches?'posterMobile':'posterDesktop']||'';video.src=src;video.load();}}
function refresh(){if(mobile.matches){video.pause();if(video.hasAttribute("src")){video.removeAttribute("src");video.load();current="";}return;}select();if(visible&&!document.hidden&&!reduced.matches)video.play().catch(()=>{});else video.pause();}
mobile.addEventListener('change',refresh);reduced.addEventListener('change',refresh);document.addEventListener('visibilitychange',refresh);
new IntersectionObserver(es=>{visible=es[0].isIntersecting;refresh();},{threshold:.05}).observe(root);refresh();
}
function init(){document.querySelectorAll('[data-sf-launch]').forEach(mount);}init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-lido-story"] && !Shopify.designMode) return;
  try {
    
function initLidoStories(){document.querySelectorAll('.sf-lido-story').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='true';
const gallery=section.querySelector('.sf-lido-story__gallery');const slides=gallery.children;
let visible=false, touched=false;
const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting},{threshold:0.3});observer.observe(gallery);
gallery.addEventListener('pointerdown',()=>touched=true);
gallery.addEventListener('pointerup',()=>touched=false);
gallery.addEventListener('pointercancel',()=>touched=false);
const timer=setInterval(()=>{
if(!section.isConnected){clearInterval(timer);observer.disconnect();return}
if(!visible||document.hidden||touched||!matchMedia('(max-width:749px)').matches||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
const stride=slides[0].offsetWidth+16;
const next=(Math.round(gallery.scrollLeft/stride)+1)%slides.length;
gallery.scrollTo({left:next*stride,behavior:'smooth'});
},3500);
})}initLidoStories();document.addEventListener('shopify:section:load',initLidoStories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-related-models"] && !Shopify.designMode) return;
  try {
    
function sfRelatedInit(){document.querySelectorAll('[data-sf-related]').forEach(section=>{if(section.dataset.randomReady)return;section.dataset.randomReady='true';const current=section.dataset.current||(new URLSearchParams(location.search).get('model')||'lido-olive');const grid=section.querySelector('.sf-related__grid');const cards=[...grid.querySelectorAll('[data-model]')];for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]];}const eligible=cards.filter(card=>card.dataset.model!==current);eligible.forEach(card=>grid.appendChild(card));const mobile=matchMedia('(max-width:749px)');function limit(){const max=mobile.matches?4:5;eligible.forEach((card,index)=>{card.hidden=index>=max;if(index>=max)card.style.setProperty('display','none','important');else card.style.removeProperty('display');});cards.filter(card=>card.dataset.model===current).forEach(card=>{card.hidden=true;card.style.setProperty('display','none','important');});}limit();mobile.addEventListener('change',limit);});}sfRelatedInit();document.addEventListener('shopify:section:load',sfRelatedInit);

  } catch(e) { console.error(e); }
})();
})();
